exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_object-gops.js
// module id = 106
// module chunks = 0